import {MessageParams} from 'commons/types/Types';

/**
 * Global App Messages.
 */
const AppMessagesTranscriber = {
    login: () =>
        'Favor de ingresar su usuario (RFC) y contrase\u00F1a para iniciar sesi\u00f3n',
    title: () => 'AML Onboarding',
    password: () =>
        'Ingresa el usuario con el que diste de alta tu cuenta, y te haremos llegar un mail con las instrucciones para restablecer tu contrase\u00f1a.',
    passwordSuccess: () => 'Solicitud de restablecimiento enviada correctamente',
    passwordError: () =>
        'Ocurri\u00F3 un error solicitando el restablecimiento de la contrase\u00F1a',
    requestedPassword: () =>
        'Se ha enviado un correo electr\u00f3nico a la direcci\u00f3n indicada con las instrucciones para restablecer tu contrase\u00f1a.',
    welcome: (param: MessageParams) => `Bienvenido ${param.username}!`,
    location: (param: MessageParams) => `Tu ubicaci\u00f3n actual es ${param.location}`,
    signatureDeclaration: () =>
        'Declaro para todos los efectos a que haya lugar, que los recursos utilizados para obtener los servicios proporcionados por Efectifintech son propios y de origen l\u00EDcito. A trav\u00E9s del presente declaro que la informaci\u00F3n y documentaci\u00F3n provista al amparo de este formato es correcta, verdadera y vigente a la fecha en la que se proporcion\u00F3 y autoriz\u00F3 a EFECTIFINTECH a que los compruebe a su entera satisfacci\u00F3n, y que en caso de que la misma cambie materialmente notificar\u00E9 tan pronto sea posible a Efectifintech.',
};

type AppMessagesKeys = keyof typeof AppMessagesTranscriber;
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type AppMessage = typeof AppMessagesTranscriber[AppMessagesKeys];

/**
 *  Return a global defined app message
 * @param key Key of message. One of AppMessagesKeys
 * @param object Object with values for template string build
 */
export function getAppMessage(key: AppMessagesKeys, object?: MessageParams) {
    return AppMessagesTranscriber[key](object ? object : {});
}
